import { Site } from '@envato/foundation-types'
import noIndexAllowList from './noIndexAllowList'
import defaultConfig from './defaults'

export default {
  name: 'PhotoDune',
  abbreviation: 'PD',
  domain: 'photodune.net',
  google_analytics_id: 'UA-11834194-35',
  google_remarketing_label: 'rsMOCJ2EugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. animals',
  ui: {
    item_list_views: [
      {
        value: 'grid',
        label: 'Grid'
      }
    ],
    featured_hero_item_viewtype: 'grid'
  },
  asset_type: 'stock photo',
  search_query: {
    default_sort_by: 'trending'
  },
  hide_sidebar_by_default: true,
  homepage: {
    newest_items_page_size: 28,
    newest_items_square: false
  },
  hide_categories: true,
  displayCategoryPage: false,
  features: {},
  forced_features: {},
  noIndex: noIndexAllowList({
    site: Site.photodune,
    routes: defaultConfig.noIndex.routes,
    params: defaultConfig.noIndex.params
  })
}
